import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { BoxDanger, BoxInfo, MnemoLoading, SupportoTecnicoLive, Title } from 'components/misc';
import { dateHelper, lessonTrainingService, networkErrorHelper } from 'libs';
import { Button, Card, CardTitle, CardBody, Icon } from 'design-react-kit';
import { ROUTES } from 'const';

class LessonTrainingDetail extends Component {

    state = {
        rCode: '',
        idLessonTraining: 0,
        loading: true,
        loadingError: false,
        userCourse: null,
        lessonTraining: null,
        fileSlides: null,
        lessonTrainingAttendance: null,
    }

    loadRemote(id, rCode) {
        lessonTrainingService
            .myTraining(id, rCode)
            .then(({ data }) => {

                const { userCourse, lessonTraining, fileSlides, lessonTrainingAttendance } = data.payload;
                this.setState({
                    userCourse,
                    lessonTraining,
                    fileSlides,
                    lessonTrainingAttendance,
                    loading: false,
                });
            })
            .catch(error => {
                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }

                this.setState({ loadingError: true, loading: false });
            });
    }

    componentDidMount() {
        const { idLessonTraining, rCode } = this.props.match.params;
        this.setState({
            idLessonTraining,
            rCode
        });

        this.loadRemote(idLessonTraining, rCode);
    }

    generateAttendee = () => {
        this.setState({ loading: true });
        const { idLessonTraining, rCode } = this.state;
        lessonTrainingService.generateAttendance({ idLessonTraining, registrationCode: rCode })
            .then(({ data }) => {
                this.setState({
                    lessonTrainingAttendance: data.payload.lessonTrainingAttendance,
                    loading: false
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                networkErrorHelper.notify(error);
            });
    }

    downloadAttendee = () => {

        const { lessonTrainingAttendance } = this.state;
        if (lessonTrainingAttendance) {
            this.setState({ loading: true });
            lessonTrainingService.donwloadAttendance(lessonTrainingAttendance.id)
                .then(({ data }) => {
                    this.setState({ loading: false });
                    // window.location = lessonTrainingAttendance.location;
                    window.open(lessonTrainingAttendance.location, '_blank');
                })
                .catch(error => {
                    this.setState({ loading: false });
                    networkErrorHelper.notify(error);
                });
        }
    }

    openFile(file) {
        const { rCode } = this.state;
        const location = `${ROUTES.COURSE_SHOW_FILE}/${rCode}/${file.id}`;
        window.location = location;
    };

    downloadFile(file) {

        window.location = file.location;
    };

    getLocation = (training) => {

        let location = 'a distanza';
        if (training.mode !== 'online') {

            location = '';

            // verify if the lcoation exists by region 
            if (training.location && this.state.userCourse?.pluginConfig?.region) {

                const tLocaltion = JSON.parse(training.location);
                location = tLocaltion[this.state.userCourse.pluginConfig.region.toUpperCase()];
            }else {

                // show the first location if the region is not set
                const tLocaltion = JSON.parse(training.location);
                const keys = Object.keys(tLocaltion);
                location = tLocaltion[keys[0]];
            }
        }
        return location;
    };

    render() {
        const {
            lessonTraining, fileSlides,
            loading, loadingError, rCode, userCourse,
            lessonTrainingAttendance } = this.state;

        let creditRecognition = false;
        if (userCourse && userCourse.creditRecognition) {
            creditRecognition = userCourse.creditRecognition;
        }

        if (loading) return <MnemoLoading />;

        return (
            <>
                <div>
                    <NavLink to='#' onClick={(e) => {
                        e.preventDefault();
                        window.history.back();
                    }} className="mx-5 btn btn-outline-primary float-right">
                        <Icon icon="it-presentation" /> TORNA INDIETRO</NavLink>
                    <Title >{lessonTraining && lessonTraining.title}</Title>
                </div>
                <div className='p-5'>
                    {loadingError && (<>
                        <BoxDanger className="mt-4">
                            Si è verificato un errore durante il caricamento dell'attività. <SupportoTecnicoLive courseCode={userCourse.courseCode} />
                        </BoxDanger>
                    </>)}
                    {lessonTraining && (
                        <div>
                            <Card noWrapper={false} tag="div" className="card-bg card-big rounded shadow border-bottom-card mb-5">
                                <div className="flag-icon" />
                                <div className="etichetta">
                                    <span >ATTIVITA'</span>
                                </div>
                                <CardBody tag="div">
                                    <CardTitle tag="h5">{lessonTraining.title}</CardTitle>
                                    <ul>
                                        <li><b>Tutor:</b> {lessonTraining.teacher}</li>
                                        <li><b>Data:</b> {dateHelper.toITDate(lessonTraining.date)}</li>
                                        <li><b>Ora inizio:</b> {dateHelper.toShortTime(lessonTraining.hourStart)}</li>
                                        { /* RIMOSSO DA PINA il 10/11/2025 <li><b>Ora fine:</b> {dateHelper.toShortTime(lessonTraining.hourEnd)}</li> */}
                                        <li><b>Argomento:</b> {lessonTraining.subject}</li>
                                        <li><b>Sede:</b> {this.getLocation(lessonTraining)}</li>
                                    </ul>
                                </CardBody>
                            </Card>
                            <Card noWrapper={false} tag="div" className="card-bg card-big rounded shadow border-bottom-card mb-5">
                                <div className="flag-icon" />
                                <div className="etichetta">
                                    <span>MATERIALE DIDATTICO</span>
                                </div>
                                <CardBody tag="div">
                                    {(fileSlides && fileSlides.length) > 0 ?
                                        <>
                                            {fileSlides.map((file, index) => (
                                                /*return <li><a key={index} href={file.location} target="_blank" rel="noopener noreferrer">{file.originalName}</a></li>*/

                                                <BoxInfo className="my-0 mnemo-dopzone-boxInfo" key={`file-${file.id}`}>
                                                    {file.originalName}
                                                    <Button
                                                        className="mx-1"
                                                        color="primary bg-dark"
                                                        size="xs"
                                                        onClick={() => this.downloadFile(file)}>
                                                        Scarica
                                                    </Button>
                                                </BoxInfo>
                                            ))
                                            }
                                        </>
                                        :
                                        <><p>Nessuna materiale didattico caricato</p></>}
                                </CardBody>
                            </Card>

                            {(lessonTraining.hasAttendance) && (
                                <Card noWrapper={false} tag="div" className="card-bg card-big rounded shadow border-bottom-card mb-5">
                                    <div className="flag-icon" />
                                    <div className="etichetta">
                                        <span >ATTESTATO DI PARTECIPAZIONE</span>
                                    </div>
                                    {(creditRecognition && lessonTraining.creditRecognition && lessonTraining.creditRecognition.includes(creditRecognition)) ? (<>
                                        <p className="btn btn-outline-primary m-1">Attività non frequentata a seguito di riconoscimento</p>
                                    </>) : (<>
                                        < CardBody tag="div">
                                            {lessonTraining.enableAttendance ?
                                                <>

                                                    {(lessonTrainingAttendance ? <>
                                                        <p>Attestato di partecipazione generato il {dateHelper.toITDate(lessonTrainingAttendance.dateGeneration)}. Scaricato {lessonTrainingAttendance.countDownload} volte.</p>
                                                        <Button onClick={this.downloadAttendee} >Scarica attestato di partecipazione</Button>
                                                    </> : <>
                                                        <Button onClick={this.generateAttendee} >Genera attestato di partecipazione</Button>
                                                    </>)}
                                                </> : <p>Attestato di partecipazione non ancora disponibile</p>
                                            }
                                        </CardBody>
                                    </>)}

                                </Card>
                            )}
                        </div>
                    )}
                </div >
            </>
        );
    }
}
export default withRouter(LessonTrainingDetail);
